import { createActivitiesQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useActivitiesQuery = createActivitiesQuery(HTTP_CONFIG.API.Consumer.url)
